function init_calculate(form, place_creator) {

    let calculate = new Calculate();

    calculate.calculate('#calculate_form');

    //====== CREATE NEW PLACE =======/

    $('body').on('click', '#place_creator', function () {
        calculate.createNewPlace(createCallback);
    });

    let createCallback = function (data) {

        let fields = Object.keys(data.clientValidate.fields);
        let form = data.clientValidate.form;
        let lower_form = form.toLowerCase();
        let place_index = data.clientValidate.index - 1;

        //Client validate
        fields.forEach(function (field) {
            $('#calculate_form').yiiActiveForm('add', {
                id: lower_form + '-places-' + place_index + '-' + field,
                name: form + '[places][' + place_index + ']' + field,
                input: '#' + lower_form + '-places-' + place_index + '-' + field,
                container: '.field-' + lower_form + '-places-' + place_index + '-' + field,
                error: '.help-block',
                validate: function (attribute, value, messages) {
                    if (value == undefined){
                        return;
                    }
                    if (value==""){
                        value=0+"";
                    }
                    yii.validation.required(value, messages, {
                        value : value.replace(',','.').replace(/[^0-9.]/g, ''),
                        message: 'Необходимо заполнить.'
                    })
                }
            })
        });

        calculate.setPlacesIndexNumber();
        calculate.calculatePlacesWeightAndVolume();
    };

    calculate.createNewPlace(createCallback); // создаем первое грузоместо при инициализации

    //====== REMOVE PLACE =======/
    $('body').on('click', '.remove-place', function () {
        let remove_index = $(this).attr('data-remove-index');
        calculate.removePlace(remove_index);
    });

    $(document.body).on('input', function (e) {
        let target = $(e.target);
        let value = target.val();

        //====== CALCULATE PLACE VOLUME =======/

        if (target.attr('class') === 'calc_volume') {
            if (value == "") {
                target.val(0);
            }
            value = value.replace(',', '.');
            target.val(value.replace(/[^0-9.]/g, ''));

            let form = $(e.target).parent('.place-sizes');
            let volume = calculate.calculateVolume($(form).find('input'));

            if (target.val()) {
                $('input[name="' + form.attr('data-for') + '"]').val(volume.toFixed(3)).trigger('change');
                calculate.calculatePlacesWeightAndVolume();
            } else {
                $('input[name="' + form.attr('data-for') + '"]').val('').trigger('change');
            }
        }

        //====== CALCULATE PLACE SIZES =======/

        if (target.attr('class') === 'form-control volume') {
            let val = target.val();

            if (val.split('.')[1]) {
                if (val.split('.')[1].length > 3) {
                    target.val(val.slice(0, -1));
                }
            }

            let form = $(target).closest('.volume-field');
            let size = calculate.calculateSize(val);

            $(form).find('.calc_volume').val(size);
            calculate.calculatePlacesWeightAndVolume();
        }

        //====== CALCULATE ALL WEIGHT AND VOLUME =======/
        if (target.attr('data-type') === 'weight') {
            calculate.calculatePlacesWeightAndVolume();
        }

        return false;
    });

    //====== SERVICE ACCORDION =======/

    $('body').on('click', '.service-label[data-accordion="true"]', function () {
        $(this).toggleClass('in');
        let id = $(this).attr('id');
        $('.service-list[data-parent="' + id + '"]').slideToggle();
    });

    $('#calculate_form').on('afterValidate', function () {

        let error = document.getElementsByClassName('has-error');

        if (error.length > 0) {
            $(error[0]).find('input').focus();
        }
    });
}